import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

// Pede ao app para usar o logo no lugar do título de texto da navigation bar.
//
// Vale só na home: ela não tem um "onde você está" para anunciar, e o título repetindo o nome da
// emissora numa tipografia que não é a da marca destoava das outras tabs, onde o título nomeia um
// lugar ou flutua sobre a arte.
//
// Quem não renderiza esta ponte continua com o título de texto, e uma build antiga do app ignora
// o elemento — o próprio bridge só envia quando o componente existe do outro lado.
export default class extends BridgeComponent {
  static component = "nav-logo"

  connect() {
    super.connect()

    this.send("connect", { label: this.bridgeElement.bridgeAttribute("label") }, () => {})
  }
}
